import React from 'react';
import './Icons.scss';

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      className="icon-facebook"
    >
      <g>
        <g className="cls-2">
          <path
            className="cls-3"
            d="M15.79,8.58A7.12,7.12,0,1,1,8.67,1.46a7.12,7.12,0,0,1,7.12,7.12"
          />
          <g id="layer1" transform="scale(0.4) ">
            <path
              className="cls-4"
              d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z"
              style={{ transform: 'translate(9px, 9px)' }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Icon;
